import script from "./DocRadioGroupRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DocRadioGroupRow.vue?vue&type=script&setup=true&lang=js"

import "./DocRadioGroupRow.vue?vue&type=style&index=0&id=0c18df6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c18df6a"]])

export default __exports__